module.exports = __webpack_public_path__ + "img/depmap_svg_V153.2543955b.svg";